// Optional config fetcher. Returns a JSON string when a live config server
// is reachable, otherwise undefined so the sim boots with defaults.
//
// Crucially: when `url` is undefined we DO NOT call fetch. The browser logs
// `Failed to load resource: net::ERR_CONNECTION_REFUSED` for every fetch
// attempt that hits a closed port, and that log fires whether or not we
// `try/catch` the resulting rejection. Skipping the call entirely is the
// only way to keep dev/audit consoles clean when no config server is
// running. (Audit 2026-07-16, finding B2.)

export async function loadOptionalConfig(url: string | undefined): Promise<string | undefined> {
  if (!url) return undefined;

  try {
    const res = await fetch(url);
    if (!res.ok) return undefined;
    return JSON.stringify(await res.json());
  } catch {
    return undefined;
  }
}
